import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import PeopleDirectory from '../../components/attendance/PeopleDirectory';
import { API_ENDPOINTS } from '../../utils/api';

const PeoplePage = () => {
  const navigate = useNavigate();
  const [people, setPeople] = useState([]);
  const [peopleLoading, setPeopleLoading] = useState(true);
  const [peopleSearch, setPeopleSearch] = useState('');
  const [selectedPerson, setSelectedPerson] = useState(null);

  const fetchPeople = useCallback(async () => {
    const token = localStorage.getItem('token');
    if (!token) return;
    try {
      setPeopleLoading(true);
      const { data } = await axios.get(API_ENDPOINTS.getUsers, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const list = Array.isArray(data) ? data : [];
      setPeople(list);
      setSelectedPerson((prev) => {
        if (prev && list.some((p) => p._id === prev._id)) return prev;
        return list[0] || null;
      });
    } catch (error) {
      console.error('Failed to fetch teammates', error);
      setPeople([]);
    } finally {
      setPeopleLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPeople();
  }, [fetchPeople]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-100 via-teal-50/30 to-slate-100 p-4 md:p-6">
      <div className="max-w-7xl mx-auto">
        <PeopleDirectory
          users={people}
          loading={peopleLoading}
          search={peopleSearch}
          setSearch={setPeopleSearch}
          onRefresh={fetchPeople}
          selected={selectedPerson}
          onSelect={setSelectedPerson}
          onBack={() => navigate('/attendance')}
        />
      </div>
    </div>
  );
};

export default PeoplePage;
